import React, { Component, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import CommonAlert from "../common/Commonalert";
import Sidebar from "../common/sidebar";
import ShowAlert from "../common/Showalert";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";
const MODULE = "manage_masterentry";

const MasterEntryEdit = () => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const [MasterValue, setMasterValue] = useState("");
  const [MasterCategory, setMasterCategory] = useState([]);
  const [premastervalue, setPreMastervalue] = useState([]);
  const [errors, setErrors] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alerterrMessage, setAlerterrMessage] = useState([]);
  const [masterlist, setMasterlist] = useState([]);
  const [MasterImage, setMasterImage] = useState(null);
  const [ExistingImage, setExistingImage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_masterentry")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    setMasterCategory(
      params.name === "productgroup"
        ? t("product_group_txt")
        : params.name === "suitablefor"
          ? t("suitable_for_txt")
          : params.name === "taxcode"
            ? t("tax_code_txt")
            : t("sector_txt")
    );
    setIsLoading(true);
    let URL = BaseUrl + `admin/product/getmasterentries/${params.id}`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        setMasterValue(responseData.MasterValue);
        setPreMastervalue(responseData.MasterValue);
        setExistingImage(responseData.MasterImage || "");
      })
      .catch((err) => {
        console.log(err);
      });
    let URL1 = BaseUrl + `admin/product/masterentries/${params.name}`;
    http
      .get(URL1)
      .then((response) => {
        let responseData1 = response.data.data;
        setMasterlist(responseData1);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, [t, params.name,params.id]);

  const routeChange = () => {
    window.location.href = `/master-entry/${params.name}`;
  };

  const btnsubmit = (e) => {
    e.preventDefault();
    if (isReadOnly) return;
    const isValid = formvalidation();
    if (isValid) {
      let Mastervalue = MasterValue.trim();
      let payload = new FormData();
      payload.append("id", params.id);
      payload.append("MasterValue", Mastervalue);
      if (params.name === "sectors" && MasterImage) {
        payload.append("MasterImage", MasterImage);
      }
      if (premastervalue != Mastervalue) {
        var isFound = masterlist.some((element) => {
          if (element.MasterValue.toLowerCase() === Mastervalue.toLowerCase()) {
            return true;
          }
          return false;
        });
      } else {
        var isFound = false;
      }
      if (isFound) {
        setAlertErrorPopup(true);
        setAlerterrMessage(t("data_already_exists_txt"));
      } else {
        var loginDetails = {};
        if (sessionStorage.getItem("authData")) {
          loginDetails = JSON.parse(sessionStorage.getItem("authData"));
        }
        let URL = BaseUrl + "admin/product/editmaster";
        http
          .put(URL, payload, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(async (response) => {
            let responseData = response.data.data;
            if (response.data.success === true) {
              setAlertPopup(true);
              setAlertMessage(
                t("master_category_updated_successfully_txt", {
                    category: MasterCategory,
                })
              );
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const formvalidation = () => {
    // const errmessage = {};
    const errmsg = {};
    let isValid = true;
    if (!MasterValue.trim()) {
      errmsg.MasterValue = t("field_required_txt");
      isValid = false;
    }
    setErrors(errmsg);
    return isValid;
  };

  const handleOnChange = (e) => {
    const re = /^[a-zA-Z0-9-' &.]*$/;
    if (e.target.name === "MasterValue") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setMasterValue(e.target.value);
      }
    }
    const { name, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  return (
    <section className="dashboard-block">
      {alerterrorPopup && <ShowAlert title={t("alert_txt")} message={alerterrMessage} />}
      {alertPopup && <CommonAlert title={t("alert_txt")} message={alertMessage} />}
      <div className="dash-right">
        <Sidebar />
      </div>
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
              <h1 className="checkout-title">
                {canEdit
                    ? `${t("edit_txt")} ${MasterCategory}`
                    : `${t("view_txt")} ${MasterCategory}`}
              </h1>
              <div className="right-table-outer-wrap">
                {isLoading ? (
                  <div className="loading-buffer"></div>
                ) : (
              <div className="form-field freeproduct-fieldset ingredients-fieldset form-container-xs">
                <form className="sectors-detail-form">
                  <div className="input-field col-1">
                    <label htmlFor="name">{MasterCategory}</label>
                    <input
                      type="text"
                      name="MasterValue"
                      value={MasterValue}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                    {errors.MasterValue && (
                      <div className="error-msg">{errors.MasterValue}</div>
                    )}
                  </div>
                  {params.name === "sectors" && (
                    <div className="input-field col-1">
                      <label>{t("sector_image_txt")}</label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => setMasterImage(e.target.files[0])}
                        disabled={isReadOnly}
                      />
                      {MasterImage ? (
                        <img
                          src={URL.createObjectURL(MasterImage)}
                          alt={t("preview_txt")}
                          style={{ width: "80px", marginTop: "10px" }}
                        />
                      ) : ExistingImage ? (
                        <img
                          src={ExistingImage}
                          alt={t("current_image_txt")}
                          style={{ width: "80px", marginTop: "10px" }}
                        />
                      ) : null}
                    </div>
                  )}
                  <div className="btnfield">
                    {canEdit && (
                      <button
                        title={t("update_txt")}
                        type="submit"
                        name="btnsubmit"
                        onClick={btnsubmit}
                      >
                        {t("update_txt")}
                      </button>
                    )}
                    <button title={t("cancel_txt")} type="button" onClick={routeChange}>
                      {t("cancel_txt")}
                    </button>
                  </div>
                </form>
              </div>
              )}
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};
export default MasterEntryEdit;
